import React from 'react';

import toiVideosStyles from "../pages/microbial_sex_video_comic/styles.module.css"
import toiGameStyles from "../pages/cybershore_meditations/styles.module.css"

export function MicrobeBackButton({id, className, image_src, onClick, tooltip, size, left, top, cursorOnHover}) {
    function HandleKeyUp(event) {
        // console.log("HandleKeyUp!", event)
        const key = event.key;
        switch (key) {
            case "Enter":
            case " ":
                onClick?.();
                break;
        }
    }

    return (
        <div className={className ? className : "MicrobeBackButton"} id={id ?? ""}>
            <img
                className={"link-image"}
                title={tooltip}
                alt={tooltip}
                src={image_src}
                style={{
                    zIndex: "100",
                    position: "fixed",
                    width: `${size}vw`,
                    top: top ? `${top}vh` : 0,
                    left: left ? `${left}vw` : 0,
                    cursor: `url(${cursorOnHover}), pointer` ?? "pointer",
                }}

                tabIndex={0}
                onClick={onClick}
                onKeyUp={HandleKeyUp}

            />
        </div>
    )

}
